import { jsx as _jsx } from "react/jsx-runtime";
import { Base_RequestTemplate } from '../../Page_BaseSandbox/Base_RequestTemplate/index.js';
import { ModuleFE_SandboxNLP } from '../../modules/ModuleFE_SandboxNLP/index.js';
import './Component_NLPRequestTemplates.scss';
export class Component_NLPRequestTemplate extends Base_RequestTemplate {
    async getTemplates() {
        return ModuleFE_SandboxNLP.listTemplates();
    }
    renderTemplate(template) {
        return _jsx("div", { className: 'predefined-option__label', children: template.label });
    }
}
//# sourceMappingURL=Component_NLPRequestTemplates.js.map